module.exports = {"id":"158790","name":"Luis Gonzalo Bustamante","rating":"73","photo":"./data/images/photos/0/158790.png","club":{"name":"Depor. Iquique","logo":"./data/images/clubs/Depor.Iquique.png"},"positions":["MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LuisGonzaloBustamante0.json
// module id = 2613
// module chunks = 0